import React, { useState } from 'react';
import { getTenant } from '../../../theme/tokens';
import { bankName, businessAddressString } from '../../../shared/config/localeProfile';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, DownloadIcon, MailIcon, EditIcon, PrinterIcon, CheckCircleIcon, XCircleIcon, MoreHorizontalIcon, ArchiveIcon, TrashIcon } from 'lucide-react';
import { Invoice } from '../../../shared/types/Invoice';
export function InvoiceDetail() {
  const {
    t
  } = useTranslation('invoices');
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  // Mock data
  const invoice: Invoice = {
    id: id || '1',
    invoiceNumber: 'INV-2024-001',
    customerName: 'Acme Corporation',
    customerEmail: 'billing@acme.com',
    customerPhone: '+60 12 345 6789',
    amount: 125000,
    currency: getTenant().currency.code,
    status: 'paid',
    dueDate: '2024-01-15',
    issueDate: '2024-01-01',
    paidDate: '2024-01-10',
    description: 'Monthly subscription fee',
    notes: 'Thank you for your business!',
    items: [{
      id: '1',
      description: 'Premium Plan Subscription',
      quantity: 1,
      unitPrice: 100000,
      total: 100000
    }, {
      id: '2',
      description: 'Additional User Licenses',
      quantity: 5,
      unitPrice: 5000,
      total: 25000
    }],
    subtotal: 125000,
    taxAmount: 0,
    discountAmount: 0,
    total: 125000
  };
  const getStatusBadge = (status: Invoice['status']) => {
    const styles = {
      draft: 'bg-gray-100 text-gray-700 border-gray-200',
      sent: 'bg-blue-50 text-blue-700 border-blue-200',
      paid: 'bg-green-50 text-green-700 border-green-200',
      overdue: 'bg-red-50 text-red-700 border-red-200',
      cancelled: 'bg-gray-100 text-gray-500 border-gray-200'
    };
    return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium border ${styles[status]}`} data-id="element-7383" data-mp="2k3qqg3o7txhw">
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>;
  };
  return <div className="max-w-[1400px] mx-auto space-y-6" data-id="element-7384" data-mp="2t3wxb6perz83">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-7385" data-mp="2y3jajg58lfgw">
        <div className="flex items-center gap-4" data-id="element-7386" data-mp="2y2zw49esp97m">
          <button onClick={() => navigate('/invoices')} className="p-2 border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-7387" data-mp="21diohow95d3a">
            <ArrowLeftIcon size={18} data-id="element-7388" data-mp="2ae77ky0i63n1" />
          </button>
          <div data-id="element-7389" data-mp="2acmbv52gcenl">
            <div className="flex items-center gap-3" data-id="element-7390" data-mp="2abui7zsf0qzy">
              <h1 className="text-xl font-semibold text-gray-900" data-id="element-7391" data-mp="2f5p6lgiytu5d">
                {invoice.invoiceNumber}
              </h1>
              {getStatusBadge(invoice.status)}
            </div>
            <p className="text-sm text-gray-500 mt-0.5" data-id="element-7392" data-mp="1mnkx7031079v">
              {invoice.customerName}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2" data-id="element-7393" data-mp="1f427yc36vhsu">
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium transition-colors" data-id="element-7394" data-mp="1a58wsqbdk2vu">
            <MailIcon size={16} data-id="element-7395" data-mp="158igc1vnr59w" />
            {t('pages.InvoiceDetail.send')}
          </button>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium transition-colors" data-id="element-7396" data-mp="117eyxaxyp16k">
            <DownloadIcon size={16} data-id="element-7397" data-mp="rdofwlkltiy9" />
            {t('pages.InvoiceDetail.download')}
          </button>
          <button onClick={() => navigate(`/invoice-form?id=${invoice.id}`)} className="flex items-center gap-2 px-4 py-2 bg-[#E2231A] hover:bg-[#C41B14] text-white text-sm font-medium rounded-lg transition-colors shadow-sm" data-id="element-7398" data-mp="mgppad05fu4t">
            <EditIcon size={16} data-id="element-7399" data-mp="8g5274n7bc5i" />
            {t('pages.InvoiceDetail.edit')}
          </button>
          <div className="relative" data-id="element-7400" data-mp="28i4oxcgh7lmg">
            <button onClick={() => setShowMoreMenu(!showMoreMenu)} aria-label="More actions" aria-expanded={showMoreMenu} className="p-2 border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-7401" data-mp="28j69q8nanmhd">
              <MoreHorizontalIcon size={18} aria-hidden="true" data-id="element-7402" data-mp="23qd5dlvqmg5t" />
            </button>
            {showMoreMenu && <>
                <div className="fixed inset-0 z-10" onClick={() => setShowMoreMenu(false)} data-id="element-7403" data-mp="1ox03o7js8phb" />

                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20" data-id="element-7404" data-mp="1fv0nfhgldpff">
                  <button onClick={() => {
                setShowMoreMenu(false);
              }} className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-7405" data-mp="1ktbytwmjc7zr">
                    <PrinterIcon size={16} className="mr-3 text-gray-400" data-id="element-7406" data-mp="3pa8fvcdyed1k" />
                    {t('pages.InvoiceDetail.print')}
                  </button>
                  <button onClick={() => {
                setShowMoreMenu(false);
              }} className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-7407" data-mp="3k9u87vg9l542">
                    <ArchiveIcon size={16} className="mr-3 text-gray-400" data-id="element-7408" data-mp="bv2egicba4kk" />
                    {t('pages.InvoiceDetail.archive')}
                  </button>
                  <div className="border-t border-gray-100 my-1" data-id="element-7409" data-mp="kwtgnd7n7t9o" />
                  <button onClick={() => {
                setShowMoreMenu(false);
              }} className="w-full flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50" data-id="element-7410" data-mp="kw0k152eek59">
                    <TrashIcon size={16} className="mr-3" data-id="element-7411" data-mp="2in38tomv0l8q" />
                    {t('pages.InvoiceDetail.delete')}
                  </button>
                </div>
              </>}
          </div>
        </div>
      </div>

      {/* Invoice Content */}
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-7412" data-mp="qn4lb9ze3k20">
        {/* Invoice Header */}
        <div className="p-8" data-id="element-7413" data-mp="10j7wt6g4sv1m">
          <div className="flex justify-between items-start mb-8" data-id="element-7414" data-mp="10jhl8plj2u57">
            <div data-id="element-7415" data-mp="14kt2o7u9092b">
              <h2 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-7416" data-mp="14lcow0qxljm5">
                {t('pages.InvoiceDetail.invoice')}
              </h2>
              <p className="text-sm text-gray-500" data-id="element-7417" data-mp="19ibgocn4heh6">{invoice.invoiceNumber}</p>
            </div>
            <div className="text-right" data-id="element-7418" data-mp="1eb4kmyarois7">
              <img src={getTenant().brand.logo?.light || getTenant().brand.logo?.dark} alt={bankName()} className="h-10 mb-3 object-contain ml-auto" data-id="element-7419" data-mp="1j9pk2vi72yfl" />

              <p className="text-sm text-gray-600" data-id="element-7420" data-mp="1sb70kezil24t">{bankName()}</p>
              <p className="text-xs text-gray-500" data-id="element-7421" data-mp="3csxyagw5hlnq">{businessAddressString()}</p>
            </div>
          </div>

          {/* Bill To & Dates */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 pb-8 border-b border-gray-100" data-id="element-7422" data-mp="38pjgplskcx86">
            <div data-id="element-7423" data-mp="33s02glvv8kg8">
              <h3 className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-7424" data-mp="33tkxecm3e5em">
                {t('pages.InvoiceDetail.bill_to')}
              </h3>
              <p className="text-sm font-semibold text-gray-900" data-id="element-7425" data-mp="ahwyl3kfpiz">
                {invoice.customerName}
              </p>
              <p className="text-sm text-gray-600 mt-0.5" data-id="element-7426" data-mp="3rjf92quodnxa">
                {invoice.customerEmail}
              </p>
              {invoice.customerPhone && <p className="text-sm text-gray-600 mt-0.5" data-id="element-7427" data-mp="3hqhpsihuzuxm">
                  {invoice.customerPhone}
                </p>}
            </div>
            <div className="text-right space-y-2" data-id="element-7428" data-mp="easo7p8sf64o">
              <div className="flex justify-end gap-4" data-id="element-7429" data-mp="ea0tegn0lcfg">
                <span className="text-sm text-gray-500" data-id="element-7430" data-mp="3isvm3cvv7ffx">
                  {t('pages.InvoiceDetail.issue_date')}
                </span>
                <span className="text-sm font-medium text-gray-900" data-id="element-7431" data-mp="3nkdj5purovvm">
                  {new Date(invoice.issueDate).toLocaleDateString('en-GB', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric'
                })}
                </span>
              </div>
              <div className="flex justify-end gap-4" data-id="element-7432" data-mp="5e8sv7u2mgzr">
                <span className="text-sm text-gray-500" data-id="element-7433" data-mp="adbv6kio2941">
                  {t('pages.InvoiceDetail.due_date')}
                </span>
                <span className="text-sm font-medium text-gray-900" data-id="element-7434" data-mp="3shx04xiunmr9">
                  {new Date(invoice.dueDate).toLocaleDateString('en-GB', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric'
                })}
                </span>
              </div>
              {invoice.paidDate && <div className="flex justify-end gap-4" data-id="element-7435" data-mp="2dl2j5cmvqdry">
                  <span className="text-sm text-gray-500" data-id="element-7436" data-mp="2djj1piphlwol">
                    {t('pages.InvoiceDetail.paid_date')}
                  </span>
                  <span className="text-sm font-medium text-green-600" data-id="element-7437" data-mp="2nj9y5pxlylrb">
                    {new Date(invoice.paidDate).toLocaleDateString('en-GB', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric'
                })}
                  </span>
                </div>}
            </div>
          </div>

          {/* Invoice Items */}
          <div className="mb-8" data-id="element-7438" data-mp="24kxj5nk0mhnt">
            <table className="w-full" data-id="element-7439" data-mp="24lyw5xklde86">
              <thead data-id="element-7440" data-mp="1zu7fcer8mmv8">
                <tr className="border-b border-gray-200" data-id="element-7441" data-mp="1ztnuoqa7dkdi">
                  <th className="py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7442" data-mp="1zs4dmxgq35ao">
                    {t('pages.InvoiceDetail.description')}
                  </th>
                  <th className="py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7443" data-mp="1735vi0clo35d">
                    {t('pages.InvoiceDetail.qty')}
                  </th>
                  <th className="py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7444" data-mp="3lnqshpj0yl1b">
                    {t('pages.InvoiceDetail.unit_price')}
                  </th>
                  <th className="py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7445" data-mp="3bo9nlablkb6e">
                    {t('pages.InvoiceDetail.total')}
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-7446" data-mp="32umx9zq5s04l">
                {invoice.items.map(item => <tr key={item.id} className="border-b border-gray-100" data-id="element-7447" data-mp="2xxwfn7ypgwh2">
                    <td className="py-3.5 text-sm text-gray-900" data-id="element-7448" data-mp="2szcuh9rxropr">
                      {item.description}
                    </td>
                    <td className="py-3.5 text-sm text-gray-900 text-right" data-id="element-7449" data-mp="2nyfbww30ksnq">
                      {item.quantity}
                    </td>
                    <td className="py-3.5 text-sm text-gray-900 text-right" data-id="element-7450" data-mp="zfuobv9dkk9a">
                      {t('pages.InvoiceDetail.usd')}{' '}
                      {item.unitPrice.toLocaleString('en-US')}
                    </td>
                    <td className="py-3.5 text-sm font-medium text-gray-900 text-right" data-id="element-7451" data-mp="18fzih3pk5m5i">
                      {t('pages.InvoiceDetail.usd')}{' '}
                      {item.total.toLocaleString('en-US')}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Totals */}
          <div className="flex justify-end mb-8" data-id="element-7452" data-mp="koc0xce6rnfw">
            <div className="w-full max-w-xs space-y-2" data-id="element-7453" data-mp="poqa4xrix3fi">
              <div className="flex justify-between py-1.5" data-id="element-7454" data-mp="ughrchoshwsz">
                <span className="text-sm text-gray-500" data-id="element-7455" data-mp="ui2li676zdqb">
                  {t('pages.InvoiceDetail.subtotal')}
                </span>
                <span className="text-sm font-medium text-gray-900" data-id="element-7456" data-mp="3t4nkb6poqbdu">
                  {t('pages.InvoiceDetail.usd')}{' '}
                  {invoice.subtotal.toLocaleString('en-US')}
                </span>
              </div>
              {!!invoice.discountAmount && invoice.discountAmount > 0 && <div className="flex justify-between py-1.5" data-id="element-7457" data-mp="3paute3y4lxw">
                  <span className="text-sm text-gray-500" data-id="element-7458" data-mp="3ossq0ulrdi2">
                    {t('pages.InvoiceDetail.discount')}
                  </span>
                  <span className="text-sm font-medium text-gray-900" data-id="element-7459" data-mp="376135zn03b2r">
                    {t('pages.InvoiceDetail.usd_2')}{' '}
                    {invoice.discountAmount.toLocaleString('en-US')}
                  </span>
                </div>}
              {!!invoice.taxAmount && invoice.taxAmount > 0 && <div className="flex justify-between py-1.5" data-id="element-7460" data-mp="3c4ujdzto9g6m">
                  <span className="text-sm text-gray-500" data-id="element-7461" data-mp="3c7golst3bjlo">
                    {t('pages.InvoiceDetail.tax')}
                  </span>
                  <span className="text-sm font-medium text-gray-900" data-id="element-7462" data-mp="rfoccaown2e8">
                    {t('pages.InvoiceDetail.usd')}{' '}
                    {invoice.taxAmount.toLocaleString('en-US')}
                  </span>
                </div>}
              <div className="flex justify-between py-2.5 border-t-2 border-gray-200" data-id="element-7463" data-mp="2e9i9s3s6etsx">
                <span className="text-base font-semibold text-gray-900" data-id="element-7464" data-mp="20do6q1e32ynq">
                  {t('pages.InvoiceDetail.total')}
                </span>
                <span className="text-base font-bold text-gray-900" data-id="element-7465" data-mp="2szz8vghc97mn">
                  {t('pages.InvoiceDetail.usd')}{' '}
                  {invoice.total.toLocaleString('en-US')}
                </span>
              </div>
            </div>
          </div>

          {/* Notes */}
          {invoice.notes && <div className="pt-6 border-t border-gray-100" data-id="element-7466" data-mp="2o8zdwgrs4zms">
              <h3 className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-7467" data-mp="3bzd5k66gcwgu">
                {t('pages.InvoiceDetail.notes')}
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7468" data-mp="3grmpn5kvz2b7">{invoice.notes}</p>
            </div>}
        </div>
      </div>

      {/* Action Cards */}
      {invoice.status === 'sent' && <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-7469" data-mp="1n4e9u0410fr8">
          <div className="px-6 py-4 flex items-center justify-between" data-id="element-7470" data-mp="1j4lxdcbihpgl">
            <div data-id="element-7471" data-mp="1e4r6h8rqkzvj">
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-7472" data-mp="1e59d8zc0ywhp">
                {t('pages.InvoiceDetail.mark_as_paid')}
              </h3>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7473" data-mp="2atywasze1v59">
                {t('pages.InvoiceDetail.confirm_that_this_invoice_has_been')}
              </p>
            </div>
            <button className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg transition-colors" data-id="element-7474" data-mp="2215a0blixvhw">
              <CheckCircleIcon size={16} data-id="element-7475" data-mp="2uihcil2f1y7t" />
              {t('pages.InvoiceDetail.mark_as_paid')}
            </button>
          </div>
        </div>}

      {invoice.status !== 'cancelled' && invoice.status !== 'paid' && <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-7476" data-mp="2x478fgm1to5z">
          <div className="px-6 py-4 flex items-center justify-between" data-id="element-7477" data-mp="321qo8kyea901">
            <div data-id="element-7478" data-mp="371cxkjb3r53k">
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-7479" data-mp="370tsi36jwb6y">
                {t('pages.InvoiceDetail.cancel_invoice')}
              </h3>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7480" data-mp="3b4hywijg50qm">
                {t('pages.InvoiceDetail.this_action_cannot_be_undone')}
              </p>
            </div>
            <button className="flex items-center gap-2 px-4 py-2 border border-red-200 text-red-600 hover:bg-red-50 text-sm font-medium rounded-lg transition-colors" data-id="element-7481" data-mp="3l0clfoqsjfyo">
              <XCircleIcon size={16} data-id="element-7482" data-mp="3uqxts3w9nyus" />
              {t('pages.InvoiceDetail.cancel_invoice')}
            </button>
          </div>
        </div>}
    </div>;
}